<template>
    <div class="tw:mt-4 tw:flex tw:flex-wrap tw:gap-2">
        <button
            :class="pillClass(modelValue === defaultId)"
            class="tw:cursor-pointer"
            @click="$emit('update:modelValue', defaultId)"
        >
            {{ defaultLabel }}
        </button>
        <button
            v-for="c in filterValues"
            :key="'list-filter-' + c.id"
            class="tw:cursor-pointer"
            @click="$emit('update:modelValue', c.id)"
            :class="pillClass(modelValue === c.id)"
        >
            {{ c.name }}
        </button>
    </div>
</template>

<script setup>
    const {defaultId, filterValues} = defineProps({
        filterValues: {type: Array, default: () => []},
        modelValue: {type: Number, default: null},
        defaultLabel: {type: String, default: window.TABS.$t('Alle')},
        defaultId: {type: Number, default: null},
    });


    const pillClass = (active) => [
        "tw:rounded-full tw:px-3 tw:py-1 tw:text-sm tw:transition tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-(--shop-primary)",
        active ? "tw:bg-(--shop-primary) tw:text-white" : "tw:bg-zinc-100 tw:text-zinc-800 tw:hover:bg-zinc-200",
    ];
</script>